export default __webpack_public_path__ + "static/media/back.e95db046.svg";